<script setup lang="ts">
  import type { IOriginItem } from '@/components/clp/types'
  import useCLPDataLayer from '@/composables/data-layers/useCLPDataLayer'

  const activeTab = defineModel<number>()
  withDefaults(
    defineProps<{
      tabs: number[]
      variant?: string | number
    }>(),
    {
      variant: 'bt-green'
    }
  )

  const selectedOrigin = useState<IOriginItem | null>('selectedOrigin')
  const { pushCLPPriceTabsDataLayer } = useCLPDataLayer()
  const setActiveTab = (tab: number) => {
    activeTab.value = tab
    pushCLPPriceTabsDataLayer({
      origin_airport_code: selectedOrigin.value?.code,
      event_category: tab
    })
  }
</script>
<template>
  <div class="tabs-container">
    <div class="tabs-auto-grid flex gap-2 sm:grid sm:gap-6">
      <button
        v-for="tab in tabs"
        :key="tab"
        class="flex h-20 min-w-24 shrink-0 cursor-pointer flex-col items-center justify-center rounded-md p-3 md:h-42"
        :class="[activeTab === tab ? `active-tab bg-${variant} shadow-${variant} ` : 'border border-border bg-white']"
        @click="setActiveTab(tab)"
      >
        <p
          class="mb-1 text-body-3 md:text-body-1"
          :class="activeTab === tab ? 'text-white' : `text-${variant}`"
        >
          <span class="inline md:hidden">{{ $t('clp.allFor') }}</span>
          <span class="hidden md:inline">{{ $t('clp.allFlightsFor') }}</span>
        </p>
        <p
          class="text-h3 md:text-h2"
          :class="activeTab === tab ? 'text-white' : 'text-bt-blue-ui'"
        >
          {{ tab }}€
        </p>
      </button>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .tabs {
    &-container {
      @media (max-width: theme('screens.sm')) {
        width: calc(100% + 2.5rem);
        margin-left: -1.25rem;
        padding-left: 1.25rem;
        overflow-x: auto;
        scrollbar-width: none;
        -ms-overflow-style: none;

        &::-webkit-scrollbar {
          display: none;
        }
      }
    }

    &-auto-grid {
      @media (min-width: theme('screens.sm')) {
        grid-template-columns: repeat(v-bind('tabs.length'), 1fr);
      }
    }
  }
</style>
